module.exports = {
	methods:{
		setBackgroundImage: function(imageURL){
			// In production, replace /dist/ and /src/ with mtvue_ prefixes
			let processedURL = imageURL;
			if (process.env.NODE_ENV === 'production') {
				processedURL = imageURL.replace(/^\/dist\//, '/mtvue_dist/');
				processedURL = processedURL.replace(/^\/src\//, '/mtvue_src/');
			}
			return {
				backgroundImage:`url('${processedURL}')`
			};
		},
		setBackgroundColor: function(color){
			return 'background-color: #'+color			
		}
  }
}



// WEBPACK FOOTER //
// ./src/mixins/common.js